<template>
  <CustomCreateDialog
    :isOkDisabled="isOkButtonDisabled"
    dialogTitle="تایید غیبت در کلاس"
    dialogId="confirm-absence-report-by-master"
    @ok="sendAbsenceReportConfirmRequest"
  >
    <p>آیا از تایید غیبت در این جلسه اطمینان دارید؟</p>
  </CustomCreateDialog>
</template>

<script>
export default {
  emits: ["sendAbsenceReportConfirmRequest"],
  props: {
    isOkButtonDisabled: {
      type: Boolean,
    },
  },
  methods: {
    sendAbsenceReportConfirmRequest() {
      this.$emit("sendAbsenceReportConfirmRequest");
    },
  },
  components: {
    CustomCreateDialog,
  },
};
import CustomCreateDialog from "@/views/components/Utils/Dialogs/CustomCreateDialog.vue";
</script>
